import { Text, TextButton } from '@cinch-labs/design-system'
import styles from './part-ex-cta.module.css'
import { TrackingEventTypes, useAnalytics } from '@cinch-nx/shared-analytics'

export interface PartExCtaProps {
  trackingValue: string
}

export const PartExCta = ({ trackingValue }: PartExCtaProps) => {
  const { trackEvent } = useAnalytics()

  const handlePartExCtaClick = () => {
    trackEvent({
      eventName: 'Click on Start your valuation link',
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: 'click',
          category: 'hero',
          label: 'start your valuation',
          action: 'select',
          type: trackingValue,
          value: 'start_my_partex_valuation',
        },
      },
    })
  }

  return (
    <div className={styles.partExCtaContainer}>
      <Text element="p" fontSize="s">
        Get a free, instant valuation:
      </Text>
      <TextButton
        element="a"
        href="/part-exchange/calculator"
        classNames={{ button: styles['partExCta'] }}
        onClick={() => handlePartExCtaClick()}
      >
        Start my part-exchange quote
      </TextButton>
    </div>
  )
}
